<template>
  <div :class="[$style.content, blue && $style.blue, red && $style.red]">
   {{value}}
  </div>
</template>

<script>
export default {
  name: 'author',
  props: {
    value: [String, Number],
    blue: Boolean,
    red: Boolean,
  },
}
</script>

<style scoped lang="scss" module>
.content {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Roboto Mono, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 3.2rem;
  line-height: 4.2rem;
  text-align: center;
  color: $white;
  flex: 1;
  height: 100%;
  border-radius: 10px;
}
.blue {
  background: #26B1FF;
}
.red {
  background: red;
}
</style>
